export const PersonnelDocumentTypes = [
    { id: 0, name: undefined },
    { id: 1, name: 'Master Consultant Agreement' },
    { id: 2, name: 'Landman Affidavit' },
    { id: 3, name: 'Contractor Information Page' },
    { id: 7, name: 'W-9' },
    { id: 8, name: 'Miscellaneous Supporting Doc' },
    { id: 9, name: 'Drug Policy' },
    { id: 10, name: 'MVR - Motor Vehicle Record' },
    { id: 11, name: 'Employee New Hire Packet' },
    { id: 12, name: 'Background' },
];

export const PersonnelInsuranceTypes = [
    { id: 0, name: undefined },
    { id: 1, name: 'Certificate of Worker\'s Comp' },
    { id: 3, name: 'Auto Insurance' },
    { id: 4, name: 'Employees Benefit' },
    { id: 5, name: 'AAPL/IRWA Membership' },
    { id: 6, name: 'Drivers License Expiration' },
];



// WEBPACK FOOTER //
// ./src/models/DocumentTypesTSDI.ts